import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { generatePath, useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';

import ROUTES_PATH from 'domain/router/routesPathConfig';

import { payCategoriesTreeSelector } from 'domain/payCategories';
import { connectedPaymentProviderIdSelector } from 'domain/paySettings';

import RouterNavLink from 'components/mui/Router/RouterNavLink';
import Categories from './Categories';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { ListItemIcon } from 'components/mui/Layouts/components/Drawer';
import { ListItemWrapper, ListItemButton } from './StyledComponents';

import PaymentRoundedIcon from '@mui/icons-material/PaymentRounded';
import ExpandLess from '@mui/icons-material/ExpandLess';

import { LayoutPayCompanyContext } from 'components/mui/Layouts/PayCompany/LayoutPayCompanyContext';

const identity = (x: unknown) => x;

const CompanyPayNavigation: React.FC = () => {
  const categories = useSelector(payCategoriesTreeSelector);
  const connectedPaymentProviderId = useSelector(connectedPaymentProviderIdSelector);
  const { toggle } = useContext(LayoutPayCompanyContext);
  const params = useParams();
  const { formatMessage } = useIntl();

  if (!connectedPaymentProviderId) {
    return null;
  }

  return (
    <List disablePadding sx={{ display: 'block' }}>
      <ListItemWrapper isActive>
        <ListItem
          component="div"
          sx={{
            p: 0,
          }}
        >
          <ListItemButton
            {...{ component: RouterNavLink, href: generatePath(ROUTES_PATH.PAY_COMPANY.absolute, params) } as any}
            selected
            isToggle={toggle}
          >
            <ListItemIcon
              sx={{
                mr: toggle ? 1 : 'auto',
                justifyContent: 'center',
                color: 'inherit',
              }}
            >
              <PaymentRoundedIcon />
            </ListItemIcon>
            <ListItemText
              disableTypography
              sx={{ display: toggle ? 'flex' : 'none', whiteSpace: 'normal', fontWeight: 500 }}
            >
              {formatMessage({ id: 'company.paymentsWorkspace', defaultMessage: 'Payments' })}
            </ListItemText>
            <ExpandLess />
          </ListItemButton>
        </ListItem>
        <Categories tree={categories} onCategoryClick={identity} />
      </ListItemWrapper>
    </List>
  );
};

export default CompanyPayNavigation;
